export const mr = {
  // Header
  header: {
    title: "आर. एम. वारस्कर",
    subtitle: "कर सल्लागार आणि प्रमाणित लेखापरीक्षक",
    nav: {
      home: "मुख्यपृष्ठ",
      about: "आमच्याबद्दल",
      services: "सेवा",
      blog: "ब्लॉग",
      contact: "संपर्क"
    },
    cta: "संपर्कात रहा"
  },

  // Hero Section
  hero: {
    badge: "प्रमाणित व्यावसायिक सेवा",
    title: "तुमचा विश्वासू भागीदार",
    titleHighlight: "कर आणि लेखापरीक्षण सेवा",
    description: "प्रामाणिकपणा आणि कौशल्यासह सर्वसमावेशक कर सल्ला, लेखापरीक्षण आणि आर्थिक सेवा प्रदान करतो.",
    location: "संपूर्ण महाराष्ट्रात सेवा",
    ctaPrimary: "सल्लामसलत नियोजित करा",
    ctaSecondary: "सेवा पहा",
    highlights: [
      { title: "आयकर आणि जीएसटी", desc: "तज्ञ कर सल्ला" },
      { title: "सोसायटी/ट्रस्ट लेखापरीक्षण", desc: "सर्वसमावेशक लेखापरीक्षण" },
      { title: "गुंतवणूक सल्ला", desc: "आर्थिक नियोजन" }
    ]
  },

  // About Section
  about: {
    badge: "आमच्याबद्दल",
    title: "तुम्ही विश्वास ठेवू शकता अशी व्यावसायिक उत्कृष्टता",
    description: "प्रामाणिकपणा आणि कौशल्याच्या बांधिलकीसह, आम्ही सर्वसमावेशक कर सल्ला, लेखापरीक्षण आणि आर्थिक सेवा प्रदान करतो ज्या व्यवसाय आणि व्यक्तींना आर्थिक सुरक्षा आणि अनुपालन साधण्यास मदत करतात.",
    stats: [
      { label: "वर्षांचा अनुभव", value: "१५+" },
      { label: "सेवा दिलेले ग्राहक", value: "१०,०००+" },
      { label: "यशस्वी लेखापरीक्षणे", value: "१,०००+" },
      { label: "ग्राहक समाधान", value: "९९.९%" }
    ],
    whyChooseTitle: "आम्हाला का निवडा",
    whyChoose: [
      {
        title: "व्यावसायिक उत्कृष्टता",
        description: "सिद्ध ट्रॅक रेकॉर्डसह कर सल्ला, लेखापरीक्षण आणि आर्थिक सेवांमध्ये अनेक वर्षांचा अनुभव."
      },
      {
        title: "विश्वास आणि प्रामाणिकता",
        description: "सर्व व्यवहारांमध्ये प्रामाणिकपणा, पारदर्शकता आणि ग्राहक-प्रथम दृष्टिकोनाच्या पायावर बांधलेले."
      },
      {
        title: "स्थानिक कौशल्य",
        description: "सिंधुदुर्ग प्रदेशाच्या व्यापार परिदृश्य आणि अनुपालन आवश्यकतांची सखोल समज."
      },
      {
        title: "वैयक्तिक सेवा",
        description: "कार्यक्षम आणि अचूक आर्थिक व्यवस्थापनासाठी संगणकीकृत प्रणालीसह अनुकूलित उपाय."
      }
    ],
    certifiedTitle: "प्रमाणित आणि परवानाधारक व्यावसायिक",
    certifiedDesc: "सर्व सेवा सर्वोच्च व्यावसायिक मानके आणि नियामक आवश्यकतांचे पालन करून प्रदान केल्या जातात."
  },

  // Services Section
  services: {
    badge: "आमच्या सेवा",
    title: "सर्वसमावेशक व्यावसायिक सेवा",
    description: "कर सल्ल्यापासून लेखापरीक्षणापर्यंत, आम्ही तुमच्या व्यवसाय आणि वैयक्तिक आर्थिक गरजा पूर्ण करण्यासाठी डिझाइन केलेल्या सेवांची संपूर्ण श्रेणी ऑफर करतो.",
    services: [
      {
        title: "आयकर आणि जीएसटी सल्ला",
        description: "व्यक्ती आणि व्यवसायांसाठी आयकर नियोजन, जीएसटी अनुपालन आणि कर ऑप्टिमायझेशन धोरणांवर तज्ञ मार्गदर्शन.",
        features: [
          "आयकर रिटर्न दाखल करणे",
          "जीएसटी नोंदणी आणि रिटर्न",
          "कर नियोजन आणि सल्ला",
          "टीडीएस अनुपालन आणि रिटर्न"
        ]
      },
      {
        title: "सहकारी सोसायटी / ट्रस्ट लेखापरीक्षण",
        description: "सहकारी संस्था आणि ट्रस्टसाठी सर्वसमावेशक लेखापरीक्षण सेवा, अनुपालन आणि आर्थिक पारदर्शकता सुनिश्चित करणे.",
        features: [
          "सोसायटी आर्थिक लेखापरीक्षणे",
          "ट्रस्ट अनुपालन पुनरावलोकन",
          "वैधानिक अहवाल",
          "अंतर्गत नियंत्रण मूल्यांकन"
        ]
      },
      {
        title: "गुंतवणूक सल्ला",
        description: "तुमची आर्थिक उद्दिष्टे साध्य करण्यात मदत करण्यासाठी गुंतवणूक नियोजन आणि संपत्ती व्यवस्थापनावर व्यावसायिक मार्गदर्शन.",
        features: [
          "गुंतवणूक नियोजन",
          "पोर्टफोलिओ व्यवस्थापन",
          "म्युच्युअल फंड सल्ला",
          "सेवानिवृत्ती नियोजन"
        ]
      },
      {
        title: "संगणकीकृत खाती",
        description: "कार्यक्षम व्यवसाय व्यवस्थापनासाठी संगणकीकृत बहीखाते आणि आर्थिक अहवालासह आधुनिक लेखा उपाय.",
        features: [
          "लेखा सॉफ्टवेअर सेटअप",
          "बहीखाते सेवा",
          "आर्थिक अहवाल निर्मिती",
          "डेटा स्थलांतर आणि बॅकअप"
        ]
      },
      {
        title: "पारपत्र सेवा",
        description: "प्रक्रिया सुलभ आणि सोपी करण्यासाठी पारपत्र अर्ज, नूतनीकरण आणि दस्तऐवजीकरणासाठी सहाय्य.",
        features: [
          "नवीन पासपोर्ट अर्ज",
          "पासपोर्ट नूतनीकरण",
          "दस्तऐवजीकरण सहाय्य",
          "अर्ज ट्रॅकिंग"
        ]
      },
      {
        title: "कंपनी लेखापरीक्षण",
        description: "सर्व आकारांच्या कंपन्यांसाठी व्यावसायिक लेखापरीक्षण सेवा, अचूकतेचे सर्वोच्च मानक राखणे.",
        features: [
          "वार्षिक आर्थिक लेखापरीक्षणे",
          "कर लेखापरीक्षण सेवा",
          "व्यवस्थापन लेखापरीक्षण",
          "योग्य परिश्रम"
        ]
      }
    ],
    keyFeatures: "मुख्य वैशिष्ट्ये:",
    learnMore: "अधिक जाणून घ्या",
    ctaTitle: "सानुकूल उपाय हवा आहे?",
    ctaDescription: "प्रत्येक व्यवसाय अद्वितीय आहे. आमच्या सेवा तुमच्या विशिष्ट आवश्यकतांनुसार कशा तयार केल्या जाऊ शकतात याबद्दल चर्चा करूया.",
    ctaButton: "विनामूल्य सल्ला मिळवा"
  },

  // Contact Section
  contact: {
    badge: "संपर्कात रहा",
    title: "चर्चा सुरू करूया",
    description: "तुम्हाला कर सल्ला, लेखापरीक्षण किंवा गुंतवणूक सल्ला हवा असो, आम्ही मदतीसाठी येथे आहोत. आज सल्लामसलतीसाठी संपर्क साधा.",
    infoTitle: "संपर्क माहिती",
    email: "ईमेल",
    phone: "फोन",
    address: "पत्ता",
    businessHours: "व्यवसाय वेळ",
    monday: "सोमवार - शुक्रवार:",
    saturday: "शनिवार:",
    sunday: "रविवार:",
    closed: "बंद",
    formTitle: "संदेश पाठवा",
    formName: "पूर्ण नाव",
    formNamePlaceholder: "तुमचे नाव प्रविष्ट करा",
    formEmail: "ईमेल पत्ता",
    formEmailPlaceholder: "your.email@example.com",
    formPhone: "फोन नंबर",
    formPhonePlaceholder: "+91 XXXXX XXXXX",
    formMessage: "संदेश",
    formMessagePlaceholder: "आम्हाला तुमच्या आवश्यकतांबद्दल सांगा...",
    formSubmit: "संदेश पाठवा",
    formSuccess: "संदेश यशस्वीरित्या पाठवला!",
    formSuccessDesc: "संपर्क साधल्याबद्दल धन्यवाद. आम्ही लवकरच तुमच्याशी संपर्क साधू."
  },

  // Footer
  footer: {
    description: "प्रामाणिकपणा आणि कौशल्यासह व्यावसायिक कर सल्ला, लेखापरीक्षण आणि आर्थिक सेवा.",
    quickLinks: "द्रुत दुवे",
    ourServices: "आमच्या सेवा",
    contactUs: "आमच्याशी संपर्क साधा",
    privacyPolicy: "गोपनीयता धोरण",
    termsOfService: "सेवा अटी",
    allRightsReserved: "सर्व हक्क राखीव."
  },

  // Blog
  blog: {
    badge: "ब्लॉग आणि अंतर्दृष्टी",
    title: "लेखापरीक्षण आणि विम्यावर तज्ञ अंतर्दृष्टी",
    description: "लेखापरीक्षण, विमा आणि आर्थिक अनुपालनातील नवीनतम अद्यतने, टिपा आणि सर्वोत्तम पद्धतींसह माहिती राहा.",
    categories: {
      all: "सर्व",
      auditing: "लेखापरीक्षण",
      insurance: "विमा",
      taxPlanning: "कर नियोजन",
      taxCompliance: "कर आणि अनुपालन"
    },
    readMore: "अधिक वाचा",
    readTime: "मिनिट वाचन",
    ctaTitle: "व्यावसायिक सल्ला हवा आहे?",
    ctaDescription: "आमचे कौशल्य लेखांपलीकडे जाते. तुमच्या विशिष्ट गरजांसाठी वैयक्तिक मार्गदर्शन मिळवा.",
    ctaButton: "सल्लामसलत नियोजित करा",
    backToBlog: "ब्लॉगवर परत",
    share: "शेअर करा",
    relatedArticles: "संबंधित लेख",
    postCta: "कृती करण्यास तयार आहात?",
    postCtaDesc: "तुमच्या विशिष्ट गरजांनुसार तयार केलेले व्यावसायिक मार्गदर्शन मिळवा. आज सल्लामसलत नियोजित करा.",
    postCtaButton: "संपर्कात रहा"
  },

  // Common
  common: {
    loading: "लोड होत आहे...",
    error: "काहीतरी चूक झाली",
    retry: "पुन्हा प्रयत्न करा",
    required: "आवश्यक फील्ड"
  }
};
